import { render, staticRenderFns } from "./exclusiveClients.vue?vue&type=template&id=5d00c7fb&scoped=true"
import script from "./exclusiveClients.vue?vue&type=script&lang=js"
export * from "./exclusiveClients.vue?vue&type=script&lang=js"
import style0 from "./exclusiveClients.vue?vue&type=style&index=0&id=5d00c7fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d00c7fb",
  null
  
)

export default component.exports